/*
  默认主题
*/
import { ls } from '@sfe/bone-cache';

export const DEFAULT_THEME = ls.get('BYBIT_THEME_KEY') || 'dark';
